import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FrattaleService } from './frattale.service';

@Injectable({
  providedIn: 'root'
})
export class DonchianService extends FrattaleService{

  folder: string = "donchian/"
  constructor(@Inject(HttpClient) protected http: HttpClient) { 
    super(http) 
  }

  ultimiM15(mkt: string, crossTrend: boolean, daAnno: number=2021, stepMedia: number=50, stepDonchian: number=10, takeprofit: number=0.9){
    let data = {
      action: this.folder+'ultimi',
      cmd: 'ultimi_m15',
      mkt: mkt,
      step_media: stepMedia,
      step_donchian: stepDonchian,
      takeprofit: takeprofit,
      daAnno: daAnno,
      fotsi2: crossTrend
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  ultimiH1(mkt: string,crossTrend: boolean, daAnno: number=2021,  stepMedia: number=50, stepDonchian: number=10, takeprofit: number=0.9){
    let data = {
      action: this.folder+'ultimi',
      cmd: 'ultimi_h1',
      mkt: mkt,
      step_media: stepMedia,
      step_donchian: stepDonchian,
      takeprofit: takeprofit,
      daAnno: daAnno,
      fotsi2: crossTrend
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  ultimiH4(mkt: string,crossTrend: boolean, daAnno: number=2021,  stepMedia: number=50, stepDonchian: number=10, takeprofit: number=0.9){
    let data = {
      action: this.folder+'ultimi',
      cmd: 'ultimi_h4',
      mkt: mkt,
      step_media: stepMedia,
      step_donchian: stepDonchian,
      takeprofit: takeprofit,
      daAnno: daAnno,
      fotsi2: crossTrend
    }
    return this.http.post(this.url, data, { headers: this.head })
  }


}
